import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuIndicator,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
  NavigationMenuViewport,
} from "~/components/ui/navigation-menu";

function smoothScroll(event: any) {
  event.preventDefault();
  const targetId = event.currentTarget.getAttribute("href");
  const targetElement = document.querySelector(targetId);

  if (targetElement) {
    targetElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}

export function JumpToSection(props: {
  sections?: { id: string; title: string }[];
}) {
  const { sections } = props;

  return (
    <NavigationMenu className="hidden md:flex">
      <NavigationMenuList>
        {sections?.map((section) => (
          <NavigationMenuItem key={section.id}>
            <NavigationMenuLink
              href={`#${section.id}`}
              onClick={smoothScroll}
              key={section.id}
              className={navigationMenuTriggerStyle()}
            >
              {section.title}
            </NavigationMenuLink>
          </NavigationMenuItem>
        ))}
        <NavigationMenuItem>
          <NavigationMenuLink
            onClick={smoothScroll}
            href="#quick-info"
            className={navigationMenuTriggerStyle()}
          >
            Back to Top
          </NavigationMenuLink>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
